/* eslint camelcase: 0 */
import { getBackVersion } from '../../config';
import api from '../api';

type ExternalAccessResponse = {
    accessEmail: string;
};

const grantExternalAccess = (
    insuranceId: string,
    email: string
): Promise<ExternalAccessResponse> =>
    api.request<ExternalAccessResponse>({
        method: 'POST',
        url: `${getBackVersion()}/agent/insurances/residential/too/${insuranceId}/external_access`,
        action: 'TOO_GRANT_EXTERNAL_ACCESS',
        data: { access_email: email },
    });

export { grantExternalAccess };
